import de from "../de.json";
import en from '../en.json';
import es from "../es.json";
import fr from "../fr.json";
import ja from "../ja.json";
import ko from "../ko.json";
import zh from "../zh.json";
import zt from "../zt.json";
import pt from "../pt.json";
import ru from "../ru.json";
import enjp from "../jp-en.json";

export const Translations = {
  'en_US': {
    global: en
  },
  'en_IN': {
    global: en,
  },
  'en_AU': {
    global: en,
  },
  'en_RU': {
    global: en,
  },
  'es_ES': {
    global: es,
  },
  'en_ES': {
    global: en,
  },
  'es_CL': {
    global: es,
  },
  'en_CL': {
    global: en,
  },
  'es_AR': {
    global: es,
  },
  'en_AR': {
    global: en,
  },
  'en_DE': {
    global: en,
  },
  'de_DE': {
    global: de,
  },
  'en_FR': {
    global: en,
  },
  'fr_FR': {
    global: fr,
  },
  'ru_RU': {
    global: ru,
  },
  'en_JP': {
    global: enjp,
  },
  'ja_JP': {
    global: ja,
  },
  'en_KR': {
    global: en,
  },
  'ko_KR': {
    global: ko,
  },
  'en_BR': {
    global: en,
  },
  'pt_BR': {
    global: pt,
  },
  'zh_CN': {
    global: zh,
  },
  'en_TW': {
    global: en,
  },
  'zt_TW': {
    global: zt,
  },
  'en_HK': {
    global: en,
  },
  'zt_HK': {
    global: zt,
  },
  "es_MX": {
    global: es,
  },
  "en_MX":{
    global: en
  },
};

export const Countries = {
  'us': {
    name: 'United States',
    defaultLanguage: 'en',
    languages: {
      en: 'English'
    }
  },
  'de': {
    name: 'Germany',
    defaultLanguage: 'de',
    secondaryLanguage: 'en',
    languages: {
      en: 'Germany - English',
      de: 'Germany - German'
    }
  },
  'fr': {
    name: 'France',
    defaultLanguage: 'fr',
    secondaryLanguage: 'en',
    languages: {
      en: 'France - English',
      fr: 'France - French'
    }
  },
  'jp': {
    name: 'Japan',
    defaultLanguage: 'ja',
    secondaryLanguage: 'en',
    languages: {
      en: 'Japan - English',
      ja: 'Japan - Japanese'
    }
  },
  'hk': {
    name: 'Hong Kong',
    defaultLanguage: 'zt',
    secondaryLanguage: 'en',
    languages: {
      en: 'Hong Kong - English',
      zt: 'Hong Kong - Chinese'
    }
  },
  'kr': {
    name: 'Korea',
    defaultLanguage: 'ko',
    languages: {
      ko: 'Korea - Korean'
    }
  },
  'cn': {
    name: 'China',
    defaultLanguage: 'zh',
    secondaryLanguage: 'en',
    languages: {
      en: 'China - English',
      zh: 'China - Chinese'
    }
  },
  'mx': {
    name: 'Mexico',
    defaultLanguage: 'es',
    secondaryLanguage: 'en',
    languages: {
      en: 'Mexico - English',
      es: 'Mexico - Spanish'
    }
  },
  'ar': {
    name: 'Argentina',
    defaultLanguage: 'es',
    secondaryLanguage: 'en',
    languages: {
      en: 'Argentina - English',
      es: 'Argentina - Spanish'
    }
  },
  'cl': {
    name: 'Chile',
    defaultLanguage: 'es',
    secondaryLanguage: 'en',
    languages: {
      en: 'Chile - English',
      es: 'Chile - Spanish'
    }
  },
  'es': {
    name: 'Spain',
    defaultLanguage: 'es',
    secondaryLanguage: 'en',
    languages: {
      en: 'Spain - English',
      es: 'Spain - Spanish'
    }
  },
  'tw': {
    name: 'Taiwan',
    defaultLanguage: 'zt',
    secondaryLanguage: 'en',
    languages: {
      en: 'Taiwan - English',
      zt: 'Taiwan - Chinese'
    }
  },
  'br': {
    name: 'Brasil',
    defaultLanguage: 'pt',
    secondaryLanguage: 'en',
    languages: {
      pt: 'Brasil - Portuguese',
      en: 'Brasil - English'
    }
  },
  'ru': {
    name: 'Russia',
    defaultLanguage: 'ru',
    secondaryLanguage: 'en',
    languages: {
      ru: 'Russia - Russian',
      en: 'Russia - English'
    }
  }
}
